import React, { useEffect, useState, useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import notification from '../../components/notification.component';
import { ConfigContextUtils } from '../../context/contextUtils.context';
import functionApi from './tipos_salidas.function';

const action = {
    "M": {
        operation: "update",
        message: "Tipo de salida actualizado.",
    },
    "I": {
        operation: "create",
        message: "Tipo de salida registrado.",
    },
}   

export default function TiposSalidasForm({ updateValues = null, refreshData = () => {} }) {

  const { setPreloader } = useContext(ConfigContextUtils); 
  const { register, handleSubmit, reset, errors, setValue } = useForm();
  const [modo, setModo] = useState('I');
  const [updateId, setUpdateId] = useState(null);

  const onSubmit = data => {
      setPreloader(true);

      const payload = {
          ...data,
          ...(modo === 'M' && { id: updateId })
      }

      functionApi[action[modo].operation](payload)
      .then(() => {
          notification.success(action[modo].message);
          setPreloader(false);
          refreshData();
          reset({});
          setModo('I');
      });
  }

  useEffect(() => {
    if (updateValues) {
        reset(updateValues);
        setUpdateId(updateValues.id);
        setModo('M');
    }
  },[updateValues]);


  const cancelOperation = () => {
        reset({});
        setModo('I');  
        setUpdateId(null);
  }


  return (
    <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
            <Col>
                <div className="grupo-input">
                <small>Nombre de salida</small>
                    <input 
                        type="text" 
                        className={`form-control input-border ${errors.description && "is-invalid"}`} 
                        name="description" ref={register({ required: true })}
                    />
                </div>
            </Col>
            <Col>
                <div className="grupo-input">
                <small>Prefijo</small>
                    <input 
                        type="text" 
                        className={`form-control input-border ${errors.prefijo && "is-invalid"}`} 
                        name="prefijo" ref={register({ required: true })}
                    />
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div className="grupo-input mt-2">
                    { modo === 'I' ? 
                      <button type="submit" className="btnx btnx-warn">Registrar</button> 
                      : 
                      <button type="submit" className="btnx btnx-warn">Modificar</button>
                    }
                    {' '}<button onClick={cancelOperation} type="button" className="btnx btnx-warn">Cancelar</button>
                </div>
            </Col>
        </Row>
    </form>
  )
}
